import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import { isAppleSafari, showAddAccountAlertNew, TOAST_ERROR, isAccountConnected } from "../../../../../../../../../utils";
import { MediaBaseUrl } from "../../../../../../../../../actions/api";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";
import { connect } from 'react-redux';
import { getConnectedAccount } from "../../../../../../../../../actions/addFeedActions";
import SlackTab from "../../../../../../Feeds/AddFeeds/Slack/slackTab";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class SlackFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            error: false,
            selectedAcc: null,
            channelError: false,
            loading: false
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    handleSelect = (e) => {
        this.setState({ selectedAcc: e, channelError: false });
    }

    handleInput = (e) => {
        this.setState({ keyword: e.target.value, error: false });
    }

    onAddAccount = () => {
        showAddAccountAlertNew({ id: 20, name: "slack" }, "addFeed");
    }

    onSubmit = (isDisabledClick) => {

        const { selectedFilterId, connectedAcc, updateStep } = this.props;
        const { keyword, selectedAcc } = this.state;

        const isAccConnected = isAccountConnected({ connectedAcc });

        if (!isAccConnected) {
            TOAST_ERROR("Please connect your Slack Account to proceed");
            return;
        }

        const parentAcc = connectedAcc && connectedAcc.length > 0 ? connectedAcc[0].ConnectedAccounts.id : '';

        if ((selectedFilterId == 2) || (selectedFilterId == 1 && keyword != '')) {
            const obj = {
                networkId: 20,
                filter: selectedFilterId,
                slackkeyword: selectedFilterId == 1 ? keyword : '',
                connetedAccount: parentAcc,
                feedType: 2,
                account: selectedAcc,
                moderation: 0
            };

            this.setState({loading:true, error: false}); 

            updateStep(2, obj, () => this.setState({ loading: false }));

        } else {
            if (selectedAcc != null) {
                this.setState({ error: true });
                if (isDisabledClick) TOAST_ERROR("Please enter required details");
            } else {
                this.setState({ channelError: true });
                if (isDisabledClick) TOAST_ERROR("Please select a channel");
            }
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, () => this.props.getConnectedAccount(20), localStorage.getItem('ownerId'));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { keyword, error, loading, selectedAcc, channelError } = this.state;
        const { selectedFilterId, connectedAcc } = this.props;

        const isAccConnected = isAccountConnected({ connectedAcc });
        const connectedAccounts = isAccConnected ? connectedAcc[0].ConnectedAccounts : [];

        const isSubmitDisabled = !isAccConnected
            ? false
            : (selectedFilterId == 2 ? !selectedAcc : (!selectedAcc || !keyword.trim()));

        return (
            <div className="ob-feed-form-wrapper w-100">
                {isAccConnected ?
                    <div className="w-100 px-3">
                        {selectedFilterId == 2 ?
                            <SlackTab accounts={connectedAccounts.child} tab={'Channel'} checkBox={null} setCheckBox={() => {}} error={error} keyword={keyword} handleInput={this.handleInput} onSelect={this.handleSelect} selectAccount={selectedAcc} channelError={channelError} /> :
                            <SlackTab accounts={connectedAccounts.child} tab={'ChannelKeyword'} checkBox={null} setCheckBox={() => {}} error={error} keyword={keyword} handleInput={this.handleInput} onSelect={this.handleSelect} selectAccount={selectedAcc} channelError={channelError} />
                        }
                    </div> : <div className="otherSection text-start">
                        <div className="py-2">
                            <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3 cursor-pointer" onClick={this.onAddAccount}>
                                <span className="symbol symbol-25 me-3">
                                    <img src={`${MediaBaseUrl}social-icons/slack.svg`} alt="" />
                                </span>
                                <span className="text-dark-50 font-weight-bolder font-size-base" onClick={this.onAddAccount}>Connect Slack</span>
                            </a>
                        </div>
                    </div>
                }
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={isSubmitDisabled} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getConnectedAccount: (networkId) => dispatch(getConnectedAccount(networkId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SlackFeed)